import ProgressBar from "components/ProgressBar";

import { useChecklistProgress } from "entities/Checklist/components/Notifications/hooks";

export interface IChecklistProgress {
  dealId: number;
  packageId: number;
}

const ChecklistProgress = ({ dealId, packageId }: IChecklistProgress) => {
  const checklistProgressData = useChecklistProgress({ dealId, packageId });

  return (
    <ProgressBar
      label="progress"
      sx={{ width: "530px", flexGrow: 1 }}
      progressData={checklistProgressData}
    />
  );
};

export default ChecklistProgress;
